import type { FC, ReactNode } from 'react';

import type { DashboardWidgetType } from 'src/constants/dashboard';
import type { DashboardWidgetConfig } from 'src/types/dashboard';
import { getWidgetContextProviders } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/widgetMaps';

interface WidgetContextProviderProps {
  config: DashboardWidgetConfig;
  widgetType: DashboardWidgetType;
  children: ReactNode;
}

const WidgetContextProvider: FC<WidgetContextProviderProps> = ({
  config,
  widgetType,
  children,
}) => {
  const ContextProviders = getWidgetContextProviders(widgetType);

  return ContextProviders ? (
    ContextProviders.reduceRight(
      (acc, ContextProvider, index) => (
        <ContextProvider config={config} key={index}>
          {acc}
        </ContextProvider>
      ),
      children,
    )
  ) : (
    <>{children}</>
  );
};

export default WidgetContextProvider;
